import React, { useState, useEffect, useContext } from "react";
import Container from "../../components/layout/Container/Container";
import { IReactSelectOption } from "../../typings/models/ReactSelectOption";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { ENVMetaContext } from "../../App";
import {
  getBioCountryOfDestination,
  getBioCountryOfOrigin,
  getBreedSpeciesSpecimensDetails,
} from "../../api/apimethods";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "../LabDetails/Helper/Stepwizard";
import moment from "moment";
import { IBioMaster } from "../../typings/models/BioMaster";
import { IENVSamplesAndTests } from "../../typings/models/ENVSamplesandTests";
import { Button } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { getCAVSMaster } from "../../api/apimethods";
import { ICAVSMaster } from "../../typings/models/CAVSMaster";
import { ENVPurposeOfTest } from "../../typings/models/ENVPurposeOfTest";
import { IENVSampleDetails } from "../../typings/models/ENVSampleDetails";
import PersonalInformation from "./Helper/ProfileInformation";
import { IENVRequest } from "../../typings/interfaces/Requests/ENVRequest";
import { IlabENVPreference } from "../../typings/models/ENVPreference";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import { ILabBreedMaster } from "../../typings/models/LabBreedMaster";
import { ILabSpeciesMaster } from "../../typings/models/LabSpeciesMaster";
import { ILabSpecimenMaster } from "../../typings/models/LabSpecimenMaster";
import Loader from "../../components/molecules/Loader";
import { NotifyType } from "../../utils/app-config";
import { notify } from "../../utils";
export interface PersonalInfo {
  customerName: string;
  mobileNumber: string;
  email: string;
  address: string;
  nric: string;
  homeNumber: string;
  paymentMethod: string;
}
function CAVSENVReview() {
  let bannerName = "Application for Laboratory Testing";
  const location = useLocation();
  const state = location.state as {
    personalInfo: PersonalInfo;
    selectedType: string;
  };
  const navigate = useNavigate();
  const { message } = notify();
  const { ENVMeta } = useContext(ENVMetaContext);
  const [Preference, setPreference] = useState<IlabENVPreference[]>([]);
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [showFarmDetails, setShowFarmDetails] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [countryOfOriginOptions, setCountryOfOriginOptions] =
    useState<ICodeMasterModel[]>();
  const [countryOfDestinationOptions, setCountryOfDestinationOptions] =
    useState<ICodeMasterModel[]>();
  const [purposeOfTestOptions, setPurposeOfTestOptions] =
    useState<ENVPurposeOfTest[]>();
  const [speciesOptions, setSpeciesOptions] = useState<ILabSpeciesMaster[]>();
  const [breedOptions, setBreedOptions] = useState<ILabBreedMaster[]>();
  const [specimenOptions, setSpecimenOptions] =
    useState<ILabSpecimenMaster[]>();
  const [speciesSelectOptions, setSpeciesSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [breedSelectOptions, setBreedSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [specimenSelectOptions, setSpecimenSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [premisesCodeOptions, setpremisesCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [bioSurveillanceProgramsOptions, setBioSurveillanceProgramsOptions] =
    useState<IReactSelectOption[]>([]);
  const [ENVSampleDetails, setENVSampleDetails] = useState<IENVSampleDetails>();
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate());
  const maxdate = currentDate.toISOString().split("T")[0];
  const handleToggleForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowForm((prevShowForm) => !prevShowForm);
  };
  const handlePreviousClick = async () => {
    const meta: IENVRequest = ENVMeta.ENVMeta;
    const applicationNumber = meta?.applicationNumber;
    const actionStatus = meta?.actionStatus;
    localStorage.setItem("ismetadata", "1");
    if (applicationNumber && actionStatus) {
      const url = `/env-samples-and-tests?an=${applicationNumber}&type=${actionStatus}`;
      navigate(url);
    } else {
      navigate("/env-samples-and-tests");
    }
  };

  const handleNextClick = () => {
    const modeOfPayment = localStorage.getItem("modeOfPayment");
    const meta: IENVRequest = ENVMeta.ENVMeta;
    const purposeOfTest = meta?.labENVApplicationDetails?.purposeTest;

    if (purposeOfTest === 1 && modeOfPayment !== "Biosurveillance") {
      setErrorMessage(
        "You cannot proceed with Biosurveillance as the purpose of the test with other than Biosurveillance as the payment mode. Please select Biosurveillance as the payment mode or edit the purpose of the test in step 2."
      );
      message(NotifyType.Error, "Please check the error message.");
      return;
    }

    if (modeOfPayment === "Biosurveillance" && purposeOfTest !== 1) {
      setErrorMessage(
        "You cannot proceed with a Purpose of Application other than Biosurveillance since the payment mode is Biosurveillance. Please change the payment mode or edit the purpose of the test in step 2."
      );
      message(NotifyType.Error, "Please check the error message.");
      return;
    }

    setErrorMessage("");
    navigate("/env-cost-and-confirm");
  };
  const stepWizardConfig: IStepwizardProps = {
    currentStep: 3,
    steps: [
      {
        name: "Choose Application",
      },

      {
        name: "Samples & Tests",
      },
      {
        name: "Review",
      },
      {
        name: "Cost & Confirm",
      },
      {
        name: "Acknowledgement",
      },
    ],
  };

  const [samplesAndTests, setSamplesAndTests] = useState<IENVSamplesAndTests[]>(
    [
      {
        id: Date.now(),
        sampleMarking: "",
        species: "",
        breed: "",
        noOfSamples: 1,
        specimenDescription: "",
        antibioticSensitivityTestRequired: false,
        labENVTestDetails: [],
        longitude: "",
        latitude: "",
      },
    ]
  );

  const handleToggleFarmDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    setShowFarmDetails((prevShowFarmDetails) => !prevShowFarmDetails);
  };

  const [addressType, setAddressType] = useState<string>("");
  useEffect(() => {
    getMaster();
  }, []);

  const getMaster = async () => {
    try {
      setPageLoader(true);

      const response = await getCAVSMaster();
      if (response?.status === 200) {
        const cavsMaster: ICAVSMaster = response.data;
        const bioMaster: IBioMaster = cavsMaster.bioMasters;

        if (bioMaster) {
          const purposeTest = bioMaster.testPurpose;
          const purposeTestArr = Object.entries(purposeTest).map(
            ([name, id]) => ({
              id,
              name,
            })
          );
          setPurposeOfTestOptions(purposeTestArr);
          const bioSurveillanceProgram = bioMaster.bioSurveillancePrograms;
          if (bioSurveillanceProgram) {
            const bioSurveillanceProgramArr = bioSurveillanceProgram.map(
              (result: any) => ({
                label: result.name,
                value: result.CodeValue,
              })
            );
            setBioSurveillanceProgramsOptions(bioSurveillanceProgramArr);
          }

          const premisesMaster = bioMaster?.premisesMaster || [];
          const premisesCodeOptions = premisesMaster.map((result: any) => ({
            label: result.premisesCode,
            value: result.premisesCode,
          }));

          setpremisesCodeOptions(premisesCodeOptions);
        }
      }

      const countryRes = await getBioCountryOfDestination();
      setCountryOfDestinationOptions(countryRes?.data || []);

      const conutryRes = await getBioCountryOfOrigin();
      setCountryOfOriginOptions(conutryRes?.data || []);

      const breedspeciesresponse = await getBreedSpeciesSpecimensDetails("ENV");

      if (breedspeciesresponse.status == 200) {
        let species = breedspeciesresponse?.data?.labSpecies;

        if (species) {
          let values: any[] = Object.values(species);
          let speciesArr: any[] = Object.keys(species).map((x, ind) => {
            return {
              speciesName: values[ind].speciesName,
            };
          });
          setSpeciesOptions(speciesArr);
        }

        let breeds = breedspeciesresponse?.data?.labBreed;

        if (breeds) {
          let values: any[] = Object.values(breeds);
          let breedArr: any[] = Object.keys(breeds).map((x, ind) => {
            return {
              breedName: values[ind].breedName,
            };
          });
          setBreedOptions(breedArr);
        }

        let specimens = breedspeciesresponse?.data?.labSpecimen;

        if (specimens) {
          let values: any[] = Object.values(specimens);
          let specimensArr: any[] = Object.keys(specimens).map((x, ind) => {
            return {
              labSpecimenDescription: values[ind].labSpecimenDescription,
            };
          });
          setSpecimenOptions(specimensArr);
        }
      }

      const meta: IENVRequest = ENVMeta.ENVMeta;
      if (Object.keys(meta)?.length) {
        const {
          labENVApplicationDetails,
          labENVSampleTests,
          labENVPreference,
        } = meta;

        setENVSampleDetails(labENVApplicationDetails);
        setSamplesAndTests(labENVSampleTests);
        setPreference([labENVPreference]);
      }

      setPageLoader(false);
    } catch (ex) {
      console.error(ex);
      setPageLoader(false);
    }
  };

  useEffect(() => {
    if (speciesOptions) {
      const speciesOpts = speciesOptions.map((species) => ({
        label: species.speciesName,
        value: species.speciesName,
      }));
      setSpeciesSelectOptions(speciesOpts);
    }

    if (breedOptions) {
      const breedOpts = breedOptions.map((breed) => ({
        label: breed.breedName,
        value: breed.breedName,
      }));
      setBreedSelectOptions(breedOpts);
    }

    if (specimenOptions) {
      const specimenOpts = specimenOptions.map((specimen) => ({
        label: specimen.labSpecimenDescription,
        value: specimen.labSpecimenDescription,
      }));
      setSpecimenSelectOptions(specimenOpts);
    }
  }, [speciesOptions, breedOptions, specimenOptions]);
  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        {errorMessage && (
          <div className="info-content">
            <div className="att">
              <br />
              <div className="text-danger">
                <center>{errorMessage}</center>
              </div>
            </div>
          </div>
        )}
        <div className="row setup-content" id="step-1">
          <div className="col-md-12">
            <div className="tab-wizard-content">
              <PersonalInformation />

              <div className="personal-info">
                <div className="info-heading">
                  <h3 className="info-h3">Sample Details</h3>
                </div>
                {pageLoader ? (
                  <Loader />
                ) : (
                  <div className="info-content">
                    <div className="row-mt-2">
                      <div className="row">
                        <div className="col-lg-3">
                          <label className="form-check-label" htmlFor="">
                            Purpose of Application{" "}
                            <span className="star-red">*</span>
                          </label>
                        </div>
                        <div className="col-lg-3">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            name="purposeTest"
                            disabled
                            value={ENVSampleDetails?.purposeTest}
                          >
                            <option selected>-- Select --</option>
                            {purposeOfTestOptions &&
                              purposeOfTestOptions.map((x) => {
                                return (
                                  <option key={x.id} value={x.id}>
                                    {x.name}
                                  </option>
                                );
                              })}
                          </select>
                          {ENVSampleDetails?.purposeTest === 7 && (
                            <div className="mt-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Purpose of Application"
                                name="otherPurposeOfTest"
                                disabled
                                value={ENVSampleDetails?.otherPurposeOfTest}
                              />
                            </div>
                          )}
                        </div>

                        <div className="col-lg-3">
                          <label className="form-check-label" htmlFor="">
                            Country of Origin
                          </label>
                        </div>
                        <div className="col-lg-3">
                          <select
                            id="countryoforigin"
                            name="countryoforigin"
                            title="countryoforigin"
                            disabled
                            value={ENVSampleDetails?.countryofOrigin}
                            className="form-control"
                          >
                            <option value="" disabled hidden>
                              Choose a Country
                            </option>
                            {countryOfOriginOptions &&
                              countryOfOriginOptions.map((x) => {
                                return <option value={x.name}>{x.name}</option>;
                              })}
                          </select>
                        </div>
                      </div>

                      {/* <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-6">
                              <label
                                className="form-check-label"
                                htmlFor="samples"
                              >
                                Sample(s) to be collected or submitted?
                              </label>
                            </div>
                            <div className="col-lg-6">
                              <select
                                title="samples"
                                name="samplesCollectedOrSubmitted"
                                className="form-control"
                                value={
                                  ENVSampleDetails?.samplesCollectedOrSubmitted
                                }
                                disabled
                              >
                                <option value="Tobesubmitted">
                                  To be submitted
                                </option>
                                <option value="Tobecollected">
                                  To be collected
                                </option>
                              </select>
                            </div>
                          </div>
                        </div> */}

                      {/* {ENVSampleDetails?.samplesCollectedOrSubmitted ===
                        "Tobecollected" && (
                        <div className="row-mt-2">
                          <div className="row">
                            <div className="col-lg-3">
                              <label className="form-check-label" htmlFor="">
                                Courier Name
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <select
                                title="courierName"
                                name="courierName"
                                className="form-control"
                                disabled
                                value={ENVSampleDetails?.courierName}
                              >
                                <option value="courierOption1">
                                  Courier Option 1
                                </option>
                                <option value="courierOption2">
                                  Courier Option 2
                                </option>
                              </select>
                            </div>

                            <div className="col-lg-3">
                              <label
                                className="form-check-label"
                                htmlFor="courierTrackingNumber"
                              >
                                Courier tracking number
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <input
                                type="text"
                                id="courierTrackingNumber"
                                name="courierTrackingNumber"
                                disabled
                                value={ENVSampleDetails?.courierTrackingNo}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      )} */}

                      {ENVSampleDetails?.purposeTest === 1 && (
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="row">
                              <div className="col-lg-6">
                                <label className="form-check-label" htmlFor="">
                                  Biosurveillance Program
                                  <span className="star-red">*</span>
                                </label>
                              </div>
                              <div className="col-lg-6">
                                <div className="col-lg-12 mt-2">
                                  <select
                                    className={`form-select ${
                                      ENVSampleDetails?.bioSurveillanceProgramErrMsg
                                        ? "border-danger op05"
                                        : ""
                                    }`}
                                    aria-label="Default select example"
                                    name="bioSurveillanceProgram"
                                    value={
                                      ENVSampleDetails?.bioSurveillanceProgram
                                    }
                                    disabled
                                  >
                                    <option selected>-- Select --</option>
                                    {bioSurveillanceProgramsOptions &&
                                      bioSurveillanceProgramsOptions.map(
                                        (x) => {
                                          return (
                                            <option value={x.label}>
                                              {x.label}
                                            </option>
                                          );
                                        }
                                      )}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row mt-2">
                        <div className="col-lg-3">
                          <label className="form-check-label">
                            Sampling From Date{" "}
                            <span className="star-red">*</span>
                          </label>
                        </div>
                        <div className="col-lg-3">
                          <input
                            type="datetime-local"
                            className={`form-control ${
                              ENVSampleDetails?.samplingToDate &&
                              moment(ENVSampleDetails?.samplingToDate).isBefore(
                                moment(ENVSampleDetails?.samplingFromDate)
                              )
                                ? "border-danger"
                                : ""
                            }`}
                            name="samplingFromDate"
                            disabled
                            value={
                              ENVSampleDetails?.samplingFromDate
                                ? moment(
                                    ENVSampleDetails?.samplingFromDate
                                  ).format("YYYY-MM-DDTHH:mm")
                                : ""
                            }
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="form-check-label">
                            Sampling To Date <span className="star-red">*</span>
                          </label>
                        </div>
                        <div className="col-lg-3">
                          <input
                            type="datetime-local"
                            className={`form-control ${
                              ENVSampleDetails?.samplingFromDate &&
                              moment(ENVSampleDetails?.samplingToDate).isBefore(
                                moment(ENVSampleDetails?.samplingFromDate)
                              )
                                ? "border-danger"
                                : ""
                            }`}
                            name="samplingToDate"
                            disabled
                            value={
                              ENVSampleDetails?.samplingToDate
                                ? moment(
                                    ENVSampleDetails.samplingToDate
                                  ).format("YYYY-MM-DDTHH:mm")
                                : ""
                            }
                          />
                        </div>
                      </div>

                      <div className="row-mt-2">
                        <div className="row">
                          <div className="col-lg-3">
                            <label htmlFor="sampledBy">
                              Sampled By <span className="star-red">*</span>
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <input
                              type="text"
                              id="sampledBy"
                              name="sampledBy"
                              value={ENVSampleDetails?.sampledBy}
                              disabled
                              className="form-control"
                            />
                          </div>
                          <div className="col-lg-3">
                            <label className="form-check-label" htmlFor="">
                              Referring Veterinarian
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <input
                              type="text"
                              id="referringVeterinarian"
                              name="referringVeterinarian"
                              disabled
                              value={ENVSampleDetails?.referringVeterinarian}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row-mt-2">
                        <div className="row">
                          <div className="col-lg-3">
                            <label htmlFor="crossReference">
                              {" "}
                              Cross Reference
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <input
                              type="text"
                              id="crossReference"
                              name="crossReference"
                              value={ENVSampleDetails?.crossReference}
                              disabled
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            <a
                              href="#"
                              className="font-weight-500"
                              onClick={handleToggleFarmDetails}
                            >
                              Farm/Location Details{" "}
                              {showFarmDetails ? "[-]" : "[+]"}
                            </a>
                          </label>
                        </div>
                      </div>
                      {showFarmDetails && (
                        <>
                          {ENVSampleDetails?.farmCode && (
                            <div className="row mb-2">
                              <div className="col-lg-6">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <label
                                      className="form-check-label"
                                      htmlFor=""
                                    >
                                      Farm Code
                                    </label>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="col-lg-12 mt-2">
                                      <select
                                        className="form-select"
                                        aria-label="Default select example"
                                        name="farmCode"
                                        value={ENVSampleDetails?.farmCode}
                                        disabled
                                      >
                                        <option selected>-- Select --</option>
                                        {premisesCodeOptions.map((option) => (
                                          <option
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ))}
                                        <option
                                          key="specialFarmCode"
                                          value="specialfarmCode"
                                        >
                                          Special Farm Code
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {ENVSampleDetails?.farmCode === "specialfarmCode" && (
                            <div className="row mb-3">
                              <div className="col-lg-6">
                                <div className="row align-items-center">
                                  <div className="col-lg-6">
                                    <label
                                      className="form-check-label"
                                      htmlFor="specialFarmCode"
                                    >
                                      Special Farm Code
                                    </label>
                                  </div>
                                  <div className="col-lg-6">
                                    <input
                                      id="specialFarmCode"
                                      type="text"
                                      className="form-control"
                                      disabled
                                      name="specialFarmCode"
                                      value={
                                        ENVSampleDetails?.specialFarmCode || ""
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="row align-items-center">
                            <div className="col-lg-3">
                              <label htmlFor="latitude" className="mb-0">
                                Latitude (Decimal Degrees)
                              </label>
                            </div>

                            <div className="col-lg-3">
                              <input
                                type="text"
                                id="latitude"
                                name="latitude"
                                value={ENVSampleDetails?.latitude}
                                disabled
                                className="form-control"
                                maxLength={100}
                              />
                            </div>

                            <div className="col-lg-3">
                              <label htmlFor="longitude" className="mb-0">
                                Longitude (Decimal Degrees)
                              </label>
                            </div>

                            <div className="col-lg-3">
                              <input
                                type="text"
                                id="longitude"
                                name="longitude"
                                value={ENVSampleDetails?.longitude}
                                disabled
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="row mt-2 align-items-center">
                            <div className="col-lg-3">
                              <label htmlFor="farmName">Location Name</label>
                            </div>
                            <div className="col-lg-3">
                              <input
                                type="text"
                                id="locationName"
                                name="locationName"
                                disabled
                                value={ENVSampleDetails?.locationName}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-3">
                              <label
                                className="form-check-label"
                                htmlFor="addressType"
                              >
                                Farm/Location Address
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <div className="form-checked">
                                <label
                                  className="form-check-label"
                                  htmlFor="local"
                                >
                                  <input
                                    type="radio"
                                    id="local"
                                    name="addressType"
                                    value="Local"
                                    disabled
                                    className="form-check-input"
                                    checked={
                                      ENVSampleDetails?.addressType === "Local"
                                    }
                                  />
                                  Local
                                </label>

                                <label
                                  className="form-check-label"
                                  htmlFor="Foreign"
                                >
                                  <input
                                    type="radio"
                                    id="Foreign"
                                    name="addressType"
                                    className="form-check-input"
                                    disabled
                                    checked={
                                      ENVSampleDetails?.addressType ===
                                      "Foreign"
                                    }
                                  />
                                  Foreign
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="address">
                            <div className="row mt-2">
                              <div className="col-lg-12">
                                <div>
                                  <label htmlFor="postalCode">
                                    Postal Code
                                  </label>
                                  <input
                                    type="text"
                                    id="postalCode"
                                    name="postalCode"
                                    value={ENVSampleDetails?.postalCode}
                                    disabled
                                    className="form-control"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div>
                                <label htmlFor="streetName">
                                  Street/Road Name
                                </label>
                                <input
                                  type="text"
                                  id="streetName"
                                  name="streetName"
                                  value={ENVSampleDetails?.streetName}
                                  className="form-control"
                                  maxLength={255}
                                  disabled
                                />
                              </div>
                            </div>

                            <div className="row mt-4">
                              <div className="col-lg-4">
                                <label htmlFor="blockHouseNo">
                                  Block/House No
                                </label>
                                <input
                                  type="text"
                                  id="blockHouseNo"
                                  name="blockHouseNo"
                                  value={ENVSampleDetails?.blockHouseNo}
                                  className="form-control"
                                  disabled
                                />
                              </div>
                              <div className="block">
                                <label htmlFor="level">Level</label>
                                <input
                                  type="text"
                                  id="level"
                                  name="level"
                                  value={ENVSampleDetails?.level}
                                  className="form-control"
                                  disabled
                                />
                              </div>
                              <div className="col-lg-4">
                                <label htmlFor="unitNo">Unit No</label>
                                <input
                                  type="text"
                                  id="unitNo"
                                  name="unitNo"
                                  value={ENVSampleDetails?.unitNo}
                                  className="form-control"
                                  disabled
                                />
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div>
                                <label htmlFor="buildingName">
                                  Building Name
                                </label>
                                <input
                                  type="text"
                                  id="buildingName"
                                  name="buildingName"
                                  value={ENVSampleDetails?.buildingName}
                                  className="form-control"
                                  disabled
                                />
                              </div>
                            </div>

                            <div className="row mt-4">
                              <div className="col-lg-6">
                                <label htmlFor="CityName">City Name</label>
                                <input
                                  type="text"
                                  id="CityName"
                                  name="CityName"
                                  value={ENVSampleDetails?.cityName}
                                  className="form-control"
                                  maxLength={255}
                                  disabled
                                />
                              </div>

                              <div className="col-lg-6">
                                <label htmlFor="State">State/Province</label>
                                <input
                                  type="text"
                                  id="state"
                                  name="state"
                                  value={ENVSampleDetails?.state}
                                  className="form-control"
                                  disabled
                                />
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div>
                                <label htmlFor="country">Country</label>
                                <input
                                  type="text"
                                  id="country"
                                  name="country"
                                  value={ENVSampleDetails?.country}
                                  disabled
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="row mt-3">
                      <div className="col-lg-12">
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          <a
                            href="#"
                            className="font-weight-500"
                            onClick={handleToggleForm}
                          >
                            History & Remarks: {showForm ? "[-]" : "[+]"}
                          </a>
                        </label>
                      </div>
                    </div>
                    {showForm && (
                      <div className="row">
                        <div className="col-lg-3">
                          <label htmlFor="historyAndRemarks"></label>
                        </div>
                        <div className="col-lg-9">
                          <textarea
                            id="historyAndRemarks"
                            name="historyAndRemarks"
                            value={ENVSampleDetails?.histrory_Remarks}
                            className="form-control"
                            disabled
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="info-heading mt-2">
                <h3 className="info-h3">Samples & Tests</h3>
              </div>
              {pageLoader ? (
                <Loader />
              ) : (
                samplesAndTests &&
                samplesAndTests.map(
                  (sample: IENVSamplesAndTests, index: number) => {
                    return (
                      <div className="personal-info" key={index}>
                        <div className="clonable-block" data-toggle="cloner">
                          <div
                            className="clonable"
                            data-clone-number={index + 1}
                          >
                            <div className="info-heading">
                              <h2 className="pb-0">
                                Serial number {index + 1}
                              </h2>
                            </div>
                            <div className="info-content">
                              <div className="table-responsive mt-2 mb-2">
                                <table className="table table-striped product_table start_table">
                                  <thead>
                                    <tr>
                                      <th className="w-25">
                                        Animal Type
                                        <span className="star-red">*</span>
                                      </th>

                                      <th className="w-25">
                                        Test Information
                                        <span className="star-red">*</span>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <select
                                          className="form-select"
                                          aria-label="Default select example"
                                          value={sample.species}
                                          name="species"
                                          disabled
                                        >
                                          <option selected />
                                          {speciesOptions &&
                                            speciesOptions.map((x) => {
                                              return (
                                                <option value={x.speciesName}>
                                                  {x.speciesName}
                                                </option>
                                              );
                                            })}
                                          {/* <option value="Others">Others</option> */}
                                        </select>
                                        {sample.species === "Others" && (
                                          <input
                                            type="text"
                                            className="form-control mt-2"
                                            value={sample.otherSpecies}
                                            name="otherSpecies"
                                            disabled
                                          />
                                        )}
                                      </td>

                                      <td>
                                        <button
                                          className="btn btn-outline-success w-100 "
                                          type="button"
                                          data-bs-toggle="modal"
                                          data-bs-target="#staticBackdrop1"
                                          disabled
                                        >
                                          Search Test
                                        </button>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              Sample Marking{" "}
                                              <span className="star-red">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="text"
                                                name="sampleMarking"
                                                value={sample?.sampleMarking}
                                                maxLength={100}
                                                className={`form-control ${
                                                  !sample?.sampleMarking
                                                    ? "border-danger op05"
                                                    : ""
                                                }`}
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg tr-ignore">
                                        <div className="mb-3 ">
                                          <div className="mb-2">
                                            <label
                                              htmlFor="staticEmail"
                                              className="col-form-label"
                                            >
                                              Number of Samples
                                              <span className="star-red">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group date">
                                              <input
                                                type="number"
                                                min="1"
                                                name="noOfSamples"
                                                className="form-control"
                                                value={sample?.noOfSamples ?? 1}
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    {sample.labENVTestDetails &&
                                      sample.labENVTestDetails
                                        .filter(
                                          (test) => test.testDescription !== ""
                                        )
                                        .map((test, testIndex) => (
                                          <tr
                                            key={`test-row-${index}-${testIndex}`}
                                          >
                                            <td className="br-1">
                                              <div className="mb-3">
                                                <div className="mb-2">
                                                  <div className="test-detail">
                                                    <div
                                                      id={`testDescription-${index}-${test.labTestID}`}
                                                      className="test-description"
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          test.testDescription,
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                            <td className="fnt-wg tr-ignore">
                                              <div className="mb-3">
                                                <div className="mb-2">
                                                  <label
                                                    htmlFor={`repeatCount-${index}-${testIndex}`}
                                                    className="col-form-label float-start"
                                                  >
                                                    Number of Tests
                                                    <span className="star-red">
                                                      *
                                                    </span>
                                                  </label>
                                                  <div className="input-group date">
                                                    <input
                                                      type="number"
                                                      id={`repeatCount-${index}-${testIndex}`}
                                                      min="1"
                                                      className="form-control"
                                                      value={
                                                        test.nooftestsrequired ??
                                                        1
                                                      }
                                                      disabled
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                  </tbody>
                                </table>
                              </div>
                              <hr></hr>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )
              )}
              <div className="info-heading mt-2">
                <h3 className="info-h3">My Preference</h3>
              </div>
              {pageLoader ? (
                <Loader />
              ) : (
                Preference &&
                Preference.map((x: IlabENVPreference, ind: number) => {
                  return (
                    <div className="personal-info" key={ind}>
                      <div className="clonable-block">
                        <div className="clonable">
                          <div className="info-content">
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="row">
                                  <div className="col-lg-5">
                                    <label
                                      className="form-check-label"
                                      htmlFor="SpecialInstructions"
                                    >
                                      For Bacterial Culture Only
                                    </label>
                                  </div>
                                  <div className="col-lg-7 d-flex align-items-center">
                                    <input
                                      type="checkbox"
                                      className="form-check-input me-2"
                                      disabled
                                      name="antimicrobialSusceptibilityTestRequired"
                                      checked={
                                        x?.antimicrobialSusceptibilityTestRequired
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="antimicrobialSusceptibilityTestRequired"
                                    >
                                      Antimicrobial Susceptibility Test Required
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="row">
                                  <div className="col-lg-5">
                                    <label
                                      className="form-check-label"
                                      htmlFor="specialInstructions"
                                    >
                                      Special Instructions/ Additional
                                      Information
                                    </label>
                                  </div>
                                  <div className="col-lg-7">
                                    <textarea
                                      className="form-control"
                                      name="SpecialInstructions"
                                      value={x.specialInstructions}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="row mt-2 mt-lg-0">
                                  <div className="col-lg-5">
                                    <label
                                      className="form-check-label"
                                      htmlFor="otherRemarks"
                                    >
                                      Other Remarks
                                    </label>
                                  </div>
                                  <div className="col-lg-7">
                                    <textarea
                                      className="form-control"
                                      name="remarks"
                                      value={x.remarks}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="row">
                                  <div className="col-lg-5">
                                    <label
                                      className="form-check-label"
                                      htmlFor="supportDocuments"
                                    >
                                      Support Documents
                                    </label>
                                  </div>
                                  <div className="col-lg-7">
                                    <div className="file-view mt-2">
                                      {x?.supportDocumentName
                                        ? x.supportDocumentName
                                        : "No file attached"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 mt-3">
                                <div className="row">
                                  <div className="col-lg-5">
                                    <label
                                      className="form-check-label"
                                      htmlFor="modeOfReceiving"
                                    >
                                      Mode of receiving report
                                      <span className="star-red">*</span>
                                    </label>
                                  </div>
                                  <div className="col-lg-7">
                                    <select
                                      name="modeOfReceiving"
                                      disabled
                                      value={x?.modeOfReceiving}
                                      className="form-select"
                                      aria-label="Mode of receiving report"
                                    >
                                      <option value="" selected>
                                        Select an option
                                      </option>
                                      <option value={2}>Email</option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              {x?.modeOfReceiving === 1 && (
                                <div className="row mt-2">
                                  <div className="col-lg-6">
                                    <label className="form-check-label fw-bold mb-2">
                                      Please select the address for mailing:
                                    </label>
                                    <select
                                      name="mailingAddress"
                                      className="form-select mb-3"
                                      disabled
                                      value={x?.mailingAddress}
                                    >
                                      <option value="" selected>
                                        Please Select address
                                      </option>
                                      <option value={1}>
                                        Same as mailing address
                                      </option>
                                      <option value={2}>
                                        Same as billing address
                                      </option>
                                      <option value={3}>
                                        Others (please specify)
                                      </option>
                                    </select>

                                    {x?.mailingAddress === 3 && (
                                      <div className="col-lg-12">
                                        <textarea
                                          className="form-control mt-2"
                                          placeholder="Enter address"
                                          name="customAddress"
                                          disabled
                                          value={x?.customAddress}
                                        />
                                      </div>
                                    )}

                                    <div className="alert alert-warning mt-3">
                                      Please note that NParks is not liable for
                                      lost mail, and any additional copies of
                                      laboratory reports are subject to
                                      additional charges.
                                    </div>

                                    <div className="form-check mt-3">
                                      <input
                                        type="checkbox"
                                        className="form-check-input mt-2"
                                        id="acknowledgeCheckbox"
                                        name="acknowledge"
                                        disabled
                                        checked={x?.acknowledge || false}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="acknowledgeCheckbox"
                                      >
                                        I acknowledge the above information
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}

              <div className="text-end mt-3 mb-3">
                <button
                  className="btn btn-d btn-secondary px-4"
                  onClick={handlePreviousClick}
                >
                  Previous
                </button>

                <button
                  className="btn btn-primary px-4"
                  type="button"
                  onClick={handleNextClick}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>

      <Footer />
    </>
  );
}

export default CAVSENVReview;
